import {
  Box,
  Breadcrumbs,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  Chip,
  Stack,
  CircularProgress,
  Alert,
  Fade,
  IconButton,
  Tooltip,
  Switch,
  TableSortLabel,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import api from "../../axiosInstance";
import { Link } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { toast, ToastContainer } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
// import DeleteConfirmationDialog from "./DeleteConfirmationDialog";
import { Checkbox, FormControlLabel, Menu } from "@mui/material";
import { useAuth } from ".././access/AuthContext";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import SendIcon from "@mui/icons-material/Send";

const formatDateTime = (dateString) => {
  if (!dateString) return "-";

  const d = new Date(dateString);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // convert 0 → 12
  const hh = String(hours).padStart(2, "0");

  return `${day}/${month}/${year} ${hh}:${minutes}${ampm}`;
};
function RazorPayUsers() {
  const { user } = useAuth;
  const [openNew, setOpenNew] = useState(false);
  const handleNewClose = () => setOpenNew(false);
  const [userList, setUserList] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  const [totalElements, setTotalElements] = useState(0);

  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState(() => {
    return localStorage.getItem("rzpusers_management") || "";
  });
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [dense, setDense] = useState(true);
  const [orderBy, setOrderBy] = useState("title");
  const [order, setOrder] = useState("asc");

  //  Whenever searchQuery changes, save to localStorage
  useEffect(() => {
    if (searchQuery.trim() !== "") {
      localStorage.setItem("rzpusers_management", searchQuery);
    } else {
      localStorage.removeItem("rzpusers_management"); // optional: clear when empty
    }
  }, [searchQuery]);
  // Sorting logic
  const handleSort = (columnKey) => {
    const isAsc = orderBy === columnKey && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(columnKey);
  };

  const sortedData = useMemo(() => {
    if (!Array.isArray(userList)) return [];
    if (!orderBy) return userList;
    return [...userList].sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];
      if (aValue < bValue) return order === "asc" ? -1 : 1;
      if (aValue > bValue) return order === "asc" ? 1 : -1;
      return 0;
    });
  }, [userList, order, orderBy]);

  // padding Dense
  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  // Deletion confirm dialog box open and close.
  const handleClickOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedId(null);
  };
  // Column config and visibility state
  const allColumns = [
    {
      key: "userId",
      label: "UserId",
      filterable: true,
      cellCss: { minWidth: "100px" },
      getValue: (r) => r.userId,
    },
    {
      key: "orderId",
      label: "Order Id",
      filterable: true,
      cellCss: { minWidth: "120px" },
      getValue: (r) => r.orderId,
    },
    {
      key: "mobileNumber",
      label: "Mobile Number",
      filterable: true,
      cellCss: { minWidth: "150px" },
      getValue: (r) => r.mobileNumber ?? "-",
    },
    {
      key: "name",
      label: "Name",
      filterable: true,
      cellCss: { minWidth: "120px" },
      getValue: (r) => r.name,
    },
    {
      key: "bookIds",
      label: "Book Ids",
      filterable: true,
      cellCss: { minWidth: "100px" },
      getValue: (r) => `[ ${r.bookIds.join(",")} ]`,
    },
    {
      key: "booksPurchased",
      label: "Books Purchased ",
      filterable: true,
      cellCss: { minWidth: "170px" },
      getValue: (r) => r.booksPurchased,
    },
    {
      key: "amountRupees",
      label: "Amount Rupees",
      filterable: true,
      cellCss: { minWidth: "160px" },
      getValue: (r) => r.amountRupees,
    },
    {
      key: "purchaseDate",
      label: "Purchase Date ",
      filterable: true,
      cellCss: { minWidth: "160px" },
      getValue: (r) => formatDateTime(r.purchaseDate) ?? "-",
    },
    {
      key: "receipt",
      label: "Receipt",
      filterable: true,
      cellCss: { minWidth: "140px" },
      getValue: (r) => r.receipt || "-",
    },
    {
      key: "couponCode",
      label: "Coupon Code",
      filterable: true,
      cellCss: { minWidth: "140px" },
      getValue: (r) => r.couponCode || "-",
    },
    {
      key: "status",
      label: "Status",
      filterable: true,
      cellCss: { minWidth: "140px" },
      getValue: (r) => r.status,
    },
  ];
  const defaultVisibleKeys = new Set([
    "userId",
    "orderId",
    "name",
    "amountRupees",
    "mobileNumber",
    "purchaseDate",
    "universityName",
    "receipt",
    "status",
  ]);

  const STORAGE_KEY = "rzpUsersVisibleColumns";

  // Load saved filters from localStorage
  const savedFilters =
    JSON.parse(localStorage.getItem("rzpusersColumnFilters")) || {};
  // Initialize column filters
  const [columnFilters, setColumnFilters] = useState(savedFilters);

  // Tracks which filter input is open per column
  const [filterOpen, setFilterOpen] = useState(() =>
    allColumns.reduce((acc, col) => {
      const key = col.key || col.id;
      acc[key] = !!savedFilters[key];
      return acc;
    }, {})
  );

  // Save to localStorage whenever it changes
  useEffect(() => {
    const savedFilters = JSON.parse(
      localStorage.getItem("rzpusersColumnFilters")
    );
    if (savedFilters) {
      setColumnFilters((prev) => ({ ...prev, ...savedFilters }));
    }
  }, []);
  // Save filters to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem(
      "rzpusersColumnFilters",
      JSON.stringify(columnFilters)
    );
  }, [columnFilters]);

  const handleColumnFilterChange = (colKey, value) => {
    // Store the raw string so input works
    setColumnFilters((prev) => ({
      ...prev,
      [colKey]: value,
    }));

    // If the input is not empty, keep the filter open
    if (value.trim() !== "") {
      setFilterOpen((prev) => ({ ...prev, [colKey]: true }));
    }
  };
  // Filter Icon toggle
  const toggleFilter = (colKey) => {
    setFilterOpen((prev) => ({
      ...prev,
      [colKey]: !prev[colKey], //  toggle only this column
    }));
  };
  const filteredData = sortedData.filter((row) => {
    return Object.entries(columnFilters).every(([key, value]) => {
      if (!value?.trim()) return true; // Skip empty filters

      const cellValue = row[key];
      if (!cellValue) return false;

      //  Handle Date Joined (or any field containing "date")
      if (key === "dateJoined" || key.toLowerCase().includes("date")) {
        // Normalize both sides for comparison
        const formattedCell = cellValue.toString().toLowerCase(); // "2024-07-21"
        const searchTerm = value.toLowerCase();

        // Allow partial matching: "2024", "07", "21", etc.
        return formattedCell.includes(searchTerm);
      }
      // Default: regular string search for all other columns
      return cellValue.toString().toLowerCase().includes(value.toLowerCase());
    });
  });

  // Initialize from localStorage synchronously to avoid a race with the persister effect
  const [visibleColumns, setVisibleColumns] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) {
          const validKeys = new Set(allColumns.map((c) => c.key));
          const filtered = arr.filter((k) => validKeys.has(k));
          if (filtered.length > 0) {
            return new Set(filtered);
          }
        }
      }
    } catch {}
    return new Set(Array.from(defaultVisibleKeys));
  });

  const [columnsMenuAnchor, setColumnsMenuAnchor] = useState(null);
  const openColumnsMenu = Boolean(columnsMenuAnchor);

  // Persist column config to localStorage on change
  useEffect(() => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(Array.from(visibleColumns))
      );
    } catch {}
  }, [visibleColumns]);

  const handleOpenColumnsMenu = (e) => setColumnsMenuAnchor(e.currentTarget);
  const handleCloseColumnsMenu = () => setColumnsMenuAnchor(null);
  const toggleColumn = (key) => {
    setVisibleColumns((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  // Helper function to get boolean chip styling
  const getBooleanChip = (value) => {
    return (
      <Chip
        label={
          value === "created"
            ? "Create"
            : value === "captured"
            ? "Captured"
            : "Failed"
        }
        color={
          value === "created"
            ? "primary"
            : value === "captured"
            ? "success"
            : "error"
        }
        size="small"
        variant="outlined"
      />
    );
  };

  // Helper function to get discount type chip styling
  const getDiscountTypeChip = (type) => {
    const typeConfig = {
      percentage: { color: "primary", label: "Percentage" },
      fixed: { color: "secondary", label: "Fixed" },
      free: { color: "success", label: "Free" },
    };

    const config = typeConfig[type?.toLowerCase()] || {
      color: "default",
      label: type || "Unknown",
    };
    return <Chip label={config.label} color={config.color} size="small" />;
  };

  // Debounce input (wait 500ms after user stops typing)
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 300); // 500ms delay

    return () => {
      clearTimeout(handler); // Clear timeout when user types again
    };
  }, [searchQuery]);
  // Fetch paged coupons whenever page/rowsPerPage changes
  const [filteredDatas, setFilteredData] = useState([]);
  console.log(filteredDatas);

  // Fetch users when valid phone entered (auto trigger)
  useEffect(() => {
    if (debouncedQuery && /^\d{10}$/.test(debouncedQuery)) {
      handleSearch(debouncedQuery);
    }
  }, [page, rowsPerPage, debouncedQuery]);
  const handleSearch = () => {
    if (!searchQuery.trim()) {
      setUserList([]);
      setFilteredData([]);
      return;
    }

    setIsLoading(true);
    setError(null);

    api
      .get(`/api/userDetails/getUserRzporders`, {
        params: { page: page, size: rowsPerPage, phoneNumber: searchQuery },
      })
      .then((res) => {
        const data = res.data;
        console.log("API Response:", res);

        setUserList(Array.isArray(data?.content) ? data.content : []);
        setFilteredData(Array.isArray(data?.content) ? data.content : []);
        setTotalElements(
          typeof data?.totalElements === "number" ? data.totalElements : 0
        );
      })
      .catch((err) => {
        console.error("API Error:", err);
        setError("Failed to load users. Please try again.");
      })
      .finally(() => setIsLoading(false));
  };

  //   Page nation handel changes
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // page nation rows handles
  const handleChangeRowsPerPage = (event) => {
    const next = parseInt(event.target.value);
    setRowsPerPage(next);
    setPage(0);
  };

  const visibleColumnDefs = allColumns.filter((c) => visibleColumns.has(c.key));

  return (
    <>
      <Box>
        <ToastContainer />

        {/* Search Section */}
        <Card sx={{ boxShadow: 1 }}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "space-between",
                alignItems: { xs: "stretch", md: "center" },
                gap: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  width: { xs: "100%", md: "40%" },
                  flexDirection: "row",
                }}
              >
                <TextField
                  size="small"
                  required
                  variant="outlined"
                  placeholder="Enter 10 digits Phone number..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    flex: { xs: "0 0 80%", sm: 1 },
                  }}
                />

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSearch}
                  disabled={isLoading}
                  sx={{
                    flex: { xs: "0 0 20%", sm: "0 0 auto" },
                    minWidth: "unset",
                  }}
                >
                  {isLoading ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : (
                    <SendIcon size={18} color="inherit" />
                  )}
                </Button>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  flexWrap: "wrap",
                  justifyContent: { xs: "space-between", md: "flex-end" },
                  width: { xs: "100%", md: "auto" },
                }}
              >
                <Button
                  variant="outlined"
                  startIcon={<ViewColumnIcon />}
                  onClick={handleOpenColumnsMenu}
                  sx={{
                    fontSize: { xs: "11px", md: "12px" },
                    minWidth: { xs: "100px", sm: "auto" },
                  }}
                >
                  Columns
                </Button>

                <Menu
                  anchorEl={columnsMenuAnchor}
                  open={openColumnsMenu}
                  onClose={handleCloseColumnsMenu}
                  PaperProps={{
                    sx: { width: 250, maxHeight: 500, overflowY: "auto" },
                  }}
                >
                  {allColumns.map((col) => (
                    <FormControlLabel
                      key={col.key}
                      control={
                        <Checkbox
                          checked={visibleColumns.has(col.key)}
                          onChange={() => toggleColumn(col.key)}
                        />
                      }
                      label={col.label}
                      sx={{ pl: 1, pr: 2 }}
                    />
                  ))}
                </Menu>

                <Tooltip title="Dense padding" arrow>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={dense}
                        onChange={handleChangeDense}
                        color="primary"
                      />
                    }
                  />
                </Tooltip>
              </Box>
            </Box>
          </CardContent>
        </Card>

        {/* Error State */}
        {error && (
          <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        )}

        {/* Loading State */}
        {isLoading && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        )}
        {/* Table Section */}
        {!isLoading && (
          <Fade in={!isLoading}>
            <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: 2 }}>
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table
                  stickyHeader
                  aria-label="coupons table"
                  size={dense ? "small" : "medium"}
                >
                  <TableHead>
                    <TableRow>
                      {visibleColumnDefs.map((c) => (
                        <TableCell
                          key={c.key}
                          sx={{
                            backgroundColor: "#17479e",
                            padding: "10px 5px ",
                            color: "white",
                            fontWeight: 600,
                            ...c.cellCss,
                            position: "sticky",
                            top: 0,
                            zIndex: 3,
                          }}
                          sortDirection={orderBy === c.key ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === c.key}
                            direction={orderBy === c.key ? order : "asc"}
                            onClick={() => handleSort(c.key)}
                            sx={{
                              color: "#ffffff !important",
                              "&.Mui-active": {
                                color: "#ffffff !important",
                              },
                              "& .MuiTableSortLabel-icon": {
                                color: "#ffffff !important",
                              },
                            }}
                          >
                            {c.label}
                          </TableSortLabel>

                          {c.filterable && (
                            <IconButton
                              size="small"
                              onClick={() => toggleFilter(c.key)}
                              sx={{ color: "#fff" }}
                            >
                              {filterOpen[c.key] ? (
                                <FilterListOffIcon sx={{ fontSize: "14px" }} />
                              ) : (
                                <FilterListIcon sx={{ fontSize: "14px" }} />
                              )}
                            </IconButton>
                          )}
                          {filterOpen[c.key] && (
                            <TextField
                              size="small"
                              variant="outlined"
                              placeholder={`Search ${c.label}`}
                              value={columnFilters[c.key]}
                              onChange={(e) =>
                                handleColumnFilterChange(c.key, e.target.value)
                              }
                              sx={{
                                mt: 1,
                                width: "100%",
                                "& .MuiInputBase-root": {
                                  minHeight: "15px", // Increase input box height

                                  color: "#fff", // text color inside input
                                  "& fieldset": {
                                    borderColor: "#ffffffff", // border color
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#ffffffff", // border color on hover
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "#ffffffff", // border color when focused
                                  },
                                },
                                "& .MuiOutlinedInput-input": {
                                  py: 0.5, // Optional: adjust vertical padding of text
                                },
                              }}
                            />
                          )}
                        </TableCell>
                      ))}
                      {/* <TableCell
                        sx={{
                          backgroundColor: "#17479e",
                          color: "white",
                          fontWeight: 600,
                          minWidth: 120,
                        }}
                      >
                        Actions
                      </TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {console.log(filteredData)}
                    {Array.isArray(filteredData) && filteredData.length > 0 ? (
                      filteredData.map((row) => (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.orderId}
                          sx={{
                            "&:nth-of-type(odd)": {
                              backgroundColor: "rgba(0, 0, 0, 0.02)",
                            },
                            "&:hover": {
                              backgroundColor: "rgba(0, 0, 0, 0.04)",
                            },
                          }}
                        >
                          {visibleColumnDefs.map((c) => (
                            <TableCell
                              key={c.key}
                              sx={{
                                padding: "5px 5px",
                                align: "center",
                                ...c.cellCss,
                              }}
                            >
                              {c.key === "status"
                                ? getBooleanChip(c.getValue(row))
                                : c.key === "discountType"
                                ? getDiscountTypeChip(c.getValue(row))
                                : c.getValue(row)}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={visibleColumnDefs.length + 1}
                          sx={{ textAlign: "center", py: 4 }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: 2,
                            }}
                          >
                            <Typography variant="h6" color="text.secondary">
                              {searchQuery
                                ? "No RazorPay users found matching your search"
                                : "Search Razorpay Users by Phone Number"}
                            </Typography>
                            {searchQuery && (
                              <Button
                                variant="outlined"
                                onClick={() => setSearchQuery("")}
                                startIcon={<SearchIcon />}
                              >
                                Clear Search
                              </Button>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{ width: "100%", mb: 1 }}
              >
                <Typography
                  sx={{
                    ml: 1,
                    px: 2,
                    py: 1,
                    color: "#8D6E63",
                    fontWeight: 550,
                    fontSize: "14px",
                  }}
                >
                  NOTE: The Records with Status as " Captured " are valid
                  Payments
                </Typography>

                <TablePagination
                  rowsPerPageOptions={[10, 30, 50, 100, 200]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{
                    borderTop: "1px solid",
                    borderColor: "divider",
                    "& .MuiTablePagination-toolbar": {
                      paddingLeft: 2,
                      paddingRight: 2,
                    },
                  }}
                />
              </Box>
            </Paper>
          </Fade>
        )}
      </Box>
    </>
  );
}

export default RazorPayUsers;
